module.exports = __webpack_public_path__ + "app-static/img/ytb.62945a08.png";